import * as React from "react";
import useAddToHomescreenPrompt from "../Components/InstallAppController";
import styled from "@emotion/styled";

const ButtonElement = styled.button({
	// style
});

export default function InstallApp() {
	const [promptable, promptToInstall, isInstalled] = useAddToHomescreenPrompt();

	return promptable && !isInstalled ? (
		<ButtonElement onClick={promptToInstall}>
			💾 Installera som app
		</ButtonElement>
	) : <></>
		;
}